import { get } from "./get"

export const cosmos = {
  get,
}
